import { Component } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import ServiceNowType from "../../../../types/integration/IntegrationType";

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";
import List from "./List";
import Detail from "./Detail";


interface ServiceNowProps {
    toggleMenu: Function,
    isAdmin: boolean
}

interface ServiceNowState {
    loading: number,
    serviceNow: ServiceNowType[],
}

const initialState = {
    loading: DATA_INITIALISING,
    serviceNow: []
}

class ServiceNow extends Component<ServiceNowProps, ServiceNowState> {
    static propTypes: { toggleMenu: PropTypes.Validator<(...args: any[]) => any>, isAdmin: PropTypes.Validator<boolean>; };

    constructor(props: ServiceNowProps) {
        super(props);

        this.state = initialState;
    };

    async getData() {
        const serviceNow = await IntegrationsApi.getNotificationIntegrationData('servicenow');
        this.setState({
            loading: DATA_LOADED,
            serviceNow
        });
    }

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, serviceNow } = this.state;

        return (
            <div id="content">
                <Helmet>
                    <title>ServiceNow - Settings - DBmarlin</title>
                    <meta name="description" content="Manage ServiceNow"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="ServiceNow">
                        <Link to="/admin">Settings</Link>
                        <Link to="/admin/integrations">Integrations</Link>
                        <span>ServiceNow</span>
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                  />
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId/:profileId" element={<Detail refresh={this.refresh} serviceNow={serviceNow} isAdmin={this.props.isAdmin} />}/>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} serviceNow={serviceNow} isAdmin={this.props.isAdmin} />}/>
                        <Route path="/"
                               element={<List loading={loading} serviceNow={serviceNow} refresh={this.refresh} isAdmin={this.props.isAdmin}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

ServiceNow.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default ServiceNow;
